import { render, staticRenderFns } from "./SaSuccess.vue?vue&type=template&id=41c570b8&scoped=true"
import script from "./SaSuccess.vue?vue&type=script&lang=ts"
export * from "./SaSuccess.vue?vue&type=script&lang=ts"
import style0 from "./SaSuccess.vue?vue&type=style&index=0&id=41c570b8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c570b8",
  null
  
)

export default component.exports